// REQ-2026-632570 客诉反馈状态机（以原型 49.png 为准，共 5 态）
// 1 待处理 2 处理中 3 待客户确认 4 已完成 5 已归档
// 配色照原型：待处理=橙 处理中=蓝 待客户确认=紫 已完成=绿 已归档=灰
export const COMPLAINT_STATE_LIST = [
  { value: 1, label: '待处理', tagType: 'warning', tagClass: 'state-tag-pending' },
  { value: 2, label: '处理中', tagType: 'primary', tagClass: 'state-tag-handling' },
  { value: 3, label: '待客户确认', tagType: 'info', tagClass: 'state-tag-confirm' },
  { value: 4, label: '已完成', tagType: 'success', tagClass: 'state-tag-finished' },
  { value: 5, label: '已归档', tagType: 'info', tagClass: 'state-tag-archived' }
]

export const STATE_PENDING = 1
export const STATE_HANDLING = 2
export const STATE_WAIT_CONFIRM = 3
export const STATE_FINISHED = 4
export const STATE_ARCHIVED = 5

export function findStateItem(state) {
  return COMPLAINT_STATE_LIST.find(item => item.value === +state) || {}
}

export function findStateLabel(state) {
  return findStateItem(state).label || ''
}

export default {
  COMPLAINT_STATE_LIST,
  STATE_PENDING,
  STATE_HANDLING,
  STATE_WAIT_CONFIRM,
  STATE_FINISHED,
  STATE_ARCHIVED,
  findStateItem,
  findStateLabel
}
